// src/locales/en/business.js
export const business = {
    business: "ව්‍යාපාරය",
    businessName: "ව්‍යාපාරයේ නම",
    businessInfo: "ව්‍යාපාර තොරතුරු"
}